import React, { useEffect, useState, useRef, createElement } from 'react';
import { CalendarIcon, ClockIcon, GiftIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { RegistrationModal } from './RegistrationModal';
export function Hero({
  isPaused,
  setShowThankYou
}: {
  isPaused: boolean;
  setShowThankYou: (show: boolean) => void;
}) {
  const playerRef = useRef<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSuccess = () => {
    setIsModalOpen(false);
    setShowThankYou(true);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
    if (playerRef.current) {
      playerRef.current.pause();
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    // Load Wistia player scripts
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/1r1ngrgitd.js';
    script2.async = true;
    script2.type = 'module';
    document.head.appendChild(script2);
    // Wait for Wistia to load and get player reference
    const checkWistia = setInterval(() => {
      if (window.Wistia) {
        const player = window.Wistia.api('1r1ngrgitd');
        if (player) {
          playerRef.current = player;
          clearInterval(checkWistia);
        }
      }
    }, 100);
    return () => {
      clearInterval(checkWistia);
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  useEffect(() => {
    if (playerRef.current && isPaused) {
      playerRef.current.pause();
    }
  }, [isPaused]);
  return <section className="text-center" data-id="element-120">
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='1r1ngrgitd']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1r1ngrgitd/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:56.25%; 
          }
          .video-container {
            position: relative;
            z-index: 10;
            min-height: 200px;
          }
          .geometric-grid {
            position: absolute;
            width: 100%;
            height: 200px;
            overflow: hidden;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            z-index: 0;
            pointer-events: none;
          }
          .geometric-grid::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 200%;
            height: 300px;
            background-image: 
              linear-gradient(90deg, rgba(239, 68, 68, 0.3) 2px, transparent 2px),
              linear-gradient(0deg, rgba(239, 68, 68, 0.3) 2px, transparent 2px);
            background-size: 40px 40px;
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            transform-origin: center center;
            mask-image: radial-gradient(ellipse at center, black 35%, transparent 85%);
            -webkit-mask-image: radial-gradient(ellipse at center, black 35%, transparent 85%);
          }
          .geometric-grid::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px;
            height: 3px;
            background: rgba(239, 68, 68, 0.9);
            border-radius: 50%;
            box-shadow: 
              0 0 6px rgba(239, 68, 68, 0.8),
              0 0 10px rgba(239, 68, 68, 0.6),
              80px 40px 0 rgba(239, 68, 68, 0.9),
              80px 40px 6px rgba(239, 68, 68, 0.8),
              -80px -40px 0 rgba(239, 68, 68, 0.9),
              -80px -40px 6px rgba(239, 68, 68, 0.8);
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            animation: laserBeamHorizontal 3s linear infinite;
          }
          .geometric-grid .vertical-beams {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px;
            height: 3px;
            background: rgba(239, 68, 68, 0.9);
            border-radius: 50%;
            box-shadow: 
              0 0 6px rgba(239, 68, 68, 0.8),
              0 0 10px rgba(239, 68, 68, 0.6),
              40px 80px 0 rgba(239, 68, 68, 0.9),
              40px 80px 6px rgba(239, 68, 68, 0.8),
              -40px -80px 0 rgba(239, 68, 68, 0.9),
              -40px -80px 6px rgba(239, 68, 68, 0.8);
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            animation: laserBeamVertical 3.5s linear infinite;
          }
          @keyframes laserBeamHorizontal {
            0%, 100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(-200px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(200px);
              opacity: 0;
            }
          }
          @keyframes laserBeamVertical {
            0%, 100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(150px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(-150px);
              opacity: 0;
            }
          }
          @media (min-width: 768px) {
            .geometric-grid {
              height: 400px;
            }
            .geometric-grid::before {
              background-size: 60px 60px;
              height: 500px;
            }
            .geometric-grid::after {
              width: 4px;
              height: 4px;
              box-shadow: 
                0 0 8px rgba(239, 68, 68, 0.8),
                0 0 12px rgba(239, 68, 68, 0.6),
                120px 60px 0 rgba(239, 68, 68, 0.9),
                120px 60px 8px rgba(239, 68, 68, 0.8),
                240px 120px 0 rgba(239, 68, 68, 0.9),
                240px 120px 8px rgba(239, 68, 68, 0.8),
                -120px -60px 0 rgba(239, 68, 68, 0.9),
                -120px -60px 8px rgba(239, 68, 68, 0.8),
                -240px -120px 0 rgba(239, 68, 68, 0.9),
                -240px -120px 8px rgba(239, 68, 68, 0.8);
              animation: laserBeamHorizontal 3s linear infinite;
            }
            .geometric-grid .vertical-beams {
              width: 4px;
              height: 4px;
              box-shadow: 
                0 0 8px rgba(239, 68, 68, 0.8),
                0 0 12px rgba(239, 68, 68, 0.6),
                60px 120px 0 rgba(239, 68, 68, 0.9),
                60px 120px 8px rgba(239, 68, 68, 0.8),
                -60px 180px 0 rgba(239, 68, 68, 0.9),
                -60px 180px 8px rgba(239, 68, 68, 0.8),
                120px -60px 0 rgba(239, 68, 68, 0.9),
                120px -60px 8px rgba(239, 68, 68, 0.8);
            }
            .video-container {
              min-height: 400px;
            }
            @keyframes laserBeamHorizontal {
              0%, 100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(-300px);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(300px);
                opacity: 0;
              }
            }
            @keyframes laserBeamVertical {
              0%, 100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(250px);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(-250px);
                opacity: 0;
              }
            }
          }
        `
    }} data-id="element-121" />
      <div className="flex justify-center mb-3 md:mb-6" data-id="element-122">
        <div className="bg-gray-800/50 border-l-4 border-red-500 rounded-lg p-2 md:p-4 inline-block" data-id="element-123">
          <div className="flex flex-col gap-1.5 md:gap-3" data-id="element-124">
            <div className="flex items-center gap-2 md:gap-3" data-id="element-125">
              <CalendarIcon className="h-4 w-4 md:h-6 md:w-6 text-red-400 flex-shrink-0" data-id="element-126" />
              <span className="text-sm md:text-lg lg:text-xl font-semibold text-white" data-id="element-127">
                Martes, 6 de Enero
              </span>
            </div>
            <div className="flex items-center gap-2 md:gap-3" data-id="element-128">
              <ClockIcon className="h-4 w-4 md:h-6 md:w-6 text-red-400 flex-shrink-0" data-id="element-129" />
              <span className="text-sm md:text-lg lg:text-xl font-semibold text-white" data-id="element-130">
                7:00 PM (Hora del Este)
              </span>
            </div>
          </div>
        </div>
      </div>

      <h1 className="text-lg sm:text-2xl md:text-4xl lg:text-5xl font-bold mb-2 md:mb-6 lg:mb-8 text-red-500 leading-tight px-4 flex items-center justify-center" style={{
      fontFamily: 'Poppins, sans-serif'
    }} data-id="element-131">
        Masterclass Gratuita: Cómo Vender Productos Digitales Con IA
      </h1>
      <h2 className="text-base sm:text-xl md:text-2xl lg:text-3xl font-bold mb-3 md:mb-6 text-white leading-tight px-4" style={{
      fontFamily: 'Poppins, sans-serif'
    }} data-id="element-132">
        Al Registrarte Descarga Tu Custom Chat GPT Gratis
      </h2>
      <div className="flex justify-center relative mb-3 md:mb-6" data-id="element-133">
        <div className="geometric-grid" data-id="element-134">
          <div className="vertical-beams" data-id="element-135"></div>
        </div>
        <div className="w-full max-w-3xl px-4 video-container" data-id="element-136">
          <div className="relative rounded-lg md:rounded-2xl p-0.5 md:p-1 bg-gradient-to-br from-gray-800/50 to-gray-900/50 shadow-2xl aspect-video" data-id="element-137">
            <wistia-player media-id="1r1ngrgitd" aspect="1.7777777777777777" data-id="element-138"></wistia-player>
          </div>
        </div>
      </div>

      <div className="flex justify-center mb-3 md:mb-6" data-id="element-139">
        <div className="w-full max-w-3xl px-4" data-id="element-140">
          <div className="bg-gray-800/50 border-l-4 border-yellow-500 rounded-lg p-3 md:p-6 mb-3 md:mb-6" data-id="element-141">
            <div className="flex items-start gap-2 md:gap-4" data-id="element-142">
              <GiftIcon className="h-5 w-5 md:h-8 md:w-8 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-143" />
              <div data-id="element-144">
                <h3 className="text-xs md:text-lg lg:text-xl font-bold text-yellow-400 mb-1 md:mb-2" data-id="element-145">
                  REGALO EXCLUSIVO (VALORADO EN $297)
                </h3>
                <p className="text-xs md:text-base text-gray-200 leading-snug md:leading-relaxed" data-id="element-146">
                  Tu <span className="font-bold text-white" data-id="element-147">REGALO GRATIS</span>
                  : Un regalo sorpresa diseñado para ayudarte a implementar lo
                  que aprenderás en la masterclass en vivo de Info Commerce AI.
                  Solo lo revelaré a quienes asistan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center mb-3 md:mb-6" data-id="element-148">
        <div className="w-full max-w-3xl px-4" data-id="element-149">
          <button onClick={handleOpenModal} className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-bold py-3 md:py-5 px-6 md:px-12 shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 flex flex-col items-center justify-center touch-manipulation gap-0.5 md:gap-1" data-id="element-150">
            <div className="flex items-center justify-center text-base sm:text-lg md:text-2xl" data-id="element-151">
              RESERVA TU LUGAR GRATIS
              <span className="ml-2 md:ml-3 text-lg md:text-2xl" data-id="element-152">→</span>
            </div>
            <span className="text-[8px] md:text-[10px] font-normal" data-id="element-153">
              Y Accede Al Custom Chat GPT Gratis
            </span>
          </button>
        </div>
      </div>
      <RegistrationModal isOpen={isModalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} data-id="element-154" />
    </section>;
}
declare global {
  interface Window {
    Wistia: any;
  }
}